// extracted by mini-css-extract-plugin
export default {"resourceCheckWarningContainer":"ResourceCheckWarning--resourceCheckWarningContainer--7a11bb"};